<template>
  <!-- Component containing the University Terminology tool -->
  <div id="mainContainer" v-on:click="hideSuggestion()">
    <help-popup v-bind:show="showHelp" v-bind:text="pageText.help.text[selectedLang]" v-bind:title="pageText.help.title[selectedLang]" v-bind:selectedLang="selectedLang"></help-popup>
    <!-- Display title with an help button -->
    <div id="objectTitleContainer">
      <div id="helpButtonSizer">
      </div>
      <div id="objectTitleSizer">
        <h1>{{pageText.title[selectedLang]}}</h1>
      </div>
      <div id="helpButtonSizer" v-on:click="triggerHelp(true)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
        </svg>
      </div>
    </div>

    <div id="flexContent">
      <div id="UnivTerminoPart">
        <!-- Form where users can fill their requests -->
        <div id="UnivTerminoForm" for="termInput">
          <!-- Langage picker -->
          <div id="destinationLang">
            <langage-picker v-bind:lang="selectedFlag"></langage-picker>
          </div>
          <!-- Textbox with selfcompletion -->
          <div id="researchInput">
            <div id="searchElements">
              <input v-on:keyup.enter="redirectToCurrentPage(requestedWords)" id="inputfield" v-bind:placeholder="pageText['form']['searchInput'][selectedLang]" v-model="requestedWords" v-on:input="onchange()"/>
              <button id="submitButton" v-on:click="redirectToCurrentPage(requestedWords)" class="btn btn-primary">{{pageText['form']['button'][selectedLang]}}</button>
            </div>
            <div id="suggestions" v-if="typingSuggestions.length > 0">
              <ul id="typingSuggestions">
                <li v-on:click="redirectToCurrentPage(item)" class="suggestionItems" v-for="item in typingSuggestions" v-bind:key="item">
                  <a>{{item}}</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- Label showing error message if needed -->
          <div id="errorLabel" v-bind:class="errorMessage === '' ? 'hidden' : ''">
            <label>{{errorMessage}}</label>
          </div>
        </div>
        <!-- Contains response from the server -->
        <div id="responseSection" v-if="showAnswer">
          <!-- Left section -->
          <div id="translationFreqExprBox">
            <!-- Where the translation is showed -->
            <div id="responseBox" class="card" v-if="translation != '' || nothingFound">
              <!-- Shows translation if a translation has been found -->
              <div class="card-body" id="translationCardBody" v-if="!nothingFound">
                <h5 class="card-title">{{pageText.response.translation.title[selectedLang]}}</h5>
                <div id="searchWordDetails" v-if="selectedFlag === 'en'">
                  <span><a v-bind:href="`https://howjsay.com/how-to-pronounce-${translatedWord}`">{{pageText.response.translation.prononciation[selectedLang]}}</a></span>
                  <span><router-link v-bind:to="`/webexplorer/en/${translatedWord}`">{{pageText.response.translation.webSearch[selectedLang]}}</router-link></span>
                </div>
                <div v-for="trad in translation" v-bind:key="trad" class="translationItem">
                  <div class="flagContainer">
                    <span class="translationLangBullet">{{trad[2].toUpperCase()}}</span>
                  </div>
                  <!-- Show translation and translation details -->
                  <div class="translationItemsContainer">
                    <span>
                      <span><b>{{trad[1]}}</b>&nbsp;</span>
                      <span v-if="trad[2] === 'en' && !trad[1].includes(' ')">(<a v-bind:href="'https://howjsay.com/how-to-pronounce-' + trad[1]">{{pageText.response.translation.prononciation[selectedLang]}}</a>)</span>
                      <!-- <span>(<router-link v-bind:to="`/webexplorer/${trad[1]}`">{{pageText.response.translation.webSearch[selectedLang]}}</router-link>)&nbsp;</span> -->
                      <span v-if="trad[4] != ''"><i>{{trad[4]}}&nbsp;</i><br/></span>
                      <span v-if="trad[3] != ''" v-html="trad[3]"></span>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Shows a standard message if no translation has been found -->
              <div class="card-body" id="translationCardBody" v-if="nothingFound">
                <h5 class="card-title">{{pageText.response.translation.title[selectedLang]}}</h5>
                <div>
                  <span>{{pageText.response.translation.notFound.text[selectedLang]}}</span>
                  <ul>
                    <li><router-link :to="`/dictionaries/${selectedFlag}/${translatedWord}`">{{pageText.response.translation.notFound.links.dictionaries[selectedLang]}}</router-link></li>
                    <li v-if="selectedFlag == 'en'"><router-link :to="`/webexplorer/${translatedWord}`">{{pageText.response.translation.notFound.links.webSearch[selectedLang]}}</router-link></li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="freqExprBox" class="card" v-if="freqExpr != '' && !nothingFound">
              <div class="card-body" id="freqExprCardBody">
                <h5 class="card-title">{{pageText.response.frequentExpr.title[selectedLang]}}</h5>
                <!-- <h6 class="card-subtitle text-muted"></h6> -->
                <div id="freqExprList">
                  <ul>
                    <li v-for="expr in freqExpr" v-bind:key="expr">
                      {{expr}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        
          <div v-if="partialMatch[0].length != 0" id="partialMatchBoxContainer" class="card">
            <div class="card-body" id="partialMatchCardBody">
              <div id="partialMatchList">
                <div>
                  <h5 class="card-title">{{pageText.response.partialMatch.descriptionCompleteMatch[selectedLang]}}</h5>
                  <ul>
                    <li v-for="match in partialMatch[0]" v-bind:key="match">
                      <a v-on:click="redirectToCurrentPage(match[0])" class="partialMatch" v-html="match[0]"></a>
                      <ul>
                        <li v-for="translation in match[1]" v-bind:key="translation">{{translation[1].toUpperCase()}} : {{translation[0]}}</li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div v-if="partialMatch[1].length != 0">
                  <h5 class="card-title">{{pageText.response.partialMatch.descriptionPartialMatch[selectedLang]}}</h5>
                  <ul>
                    <li v-for="match in partialMatch[1]" v-bind:key="match">
                      <a v-on:click="redirectToCurrentPage(match[0])" class="partialMatch" v-html="match[0]"></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="tip">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">{{pageText.tip.legend[selectedLang]}}</h5>
            <h6 class="card-subtitle text-muted">{{pageText.tip.description[selectedLang]}}</h6>
            <p class="card-text" v-html="tip.question"></p>
            <ul>
                <li v-for="choice in tip.choices" v-bind:key="choice" v-html="choice"></li>
            </ul>
            <div id="showTextButton" v-on:click="displayTipAnswer()">
              <b class="card-link btn btn-primary">{{pageText.tip.answer[selectedLang]}}</b>
            </div>
            <p v-if="showTipAnswer" class="card-text" v-html="tip.answer"></p>
            <p v-if="showTipAnswer" class="card-text" v-html="tip.comment"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getUnivTerminologyTrad, getUnivTerminologyPartialMatch, getUnivTerminologyFreqExpr, getUnivTerminologySuggestions} from '../utils.js'
import LangagePicker from './LangagePicker.vue'
import HelpPopup from './HelpPopup.vue'
import {getRandomTip} from '../utils.js'

export default {
  name: 'UnivTermino',
  components : {
    LangagePicker,
    HelpPopup
  },
  data () {
    return {
      // Static text on the page
      // available in french, english and dutch
      pageText : {
        title : {
          fr : 'Recherche de terminologie universitaire',
          en : 'University terminology search',
          nl : 'Academisch terminologisch onderzoek'
        },
        form : {
          searchInput : {
            fr : 'Terme recherché : ',
            en : 'Search term : ',
            nl : 'Zoekterm : '
          },
          button : {
            fr : 'Rechercher',
            en : 'Search',
            nl : 'Zoeken'
          }
        },
        response : {
          translation : {
            title : {
              fr : 'Traduction',
              en : 'Translation',
              nl : 'Vertaling'
            },
            prononciation : {
              en : 'Pronunciation',
              fr : 'Prononciation',
              nl : 'Uitspraak' 
            },
            webSearch : {
              en : 'Search on web',
              fr : 'Recherche sur le web',
              nl : 'Zoeken op het web'
            },
            notFound : {
              text : {
                en : 'The term you are looking for is not included in the dictionary. You may find interesting information by consulting other dictionaries or by exploring English academic sites.',
                fr : 'Le terme recherché n’est pas inclus dans le dictionnaire. Vous pourriez obtenir des informations intéressantes en consultant d’autres dictionnaires ou en explorant des sites académiques anglais.',
                nl : 'De term die u zoekt, is niet in het woordenboek opgenomen. Misschien vindt u interessante informatie door andere woordenboeken te raadplegen of door Engelse academische sites te verkennen.'
              },
              links : {
                webSearch : {
                  en : 'English academic sites',
                  fr : 'Sites académiques anglais',
                  nl : 'Engelse academische sites'
                },
                dictionaries : {
                  en : 'Dictionaries',
                  fr : 'Dictionnaires',
                  nl : 'Woordenbooken'
                }
              }
            }
          },
          partialMatch : {
            completeMatch : {
              fr : 'Correspondances complètes',
              en : 'Complete matches',
              nl : 'Volledige wedstrijden'
            },
            descriptionCompleteMatch : {
              fr : 'Correspondances contenant vos mots de votre recherche',
              en : 'Matches containing your search word(s)',
              nl : 'Overeenkomsten die alle woorden in uw zoekopdracht bevatten'
            },
            partialMatch : {
              fr : 'Correspondances partielles',
              en : 'Partial matches',
              nl : 'Gedeeltelijke overeenkomsten '
            },
            descriptionPartialMatch : {
              fr : 'Correspondances contenant au moins un mot de votre recherche',
              en : 'Matches containing at least one word in your search',
              nl : 'Overeenkomsten die ten minste één woord in uw zoekopdracht bevatten'
            }
          },
          frequentExpr : {
            title : {
              fr : 'Expressions fréquentes',
              en : 'Frequent expressions',
              nl : 'Veel voorkomende uitdrukkingen '
            }
          }
        },
        help : {
          title : {
            fr : "Utilisation du moteur de recherche de terminologie universitaire",
            en : "Using the university terminology search engine",
            nl : "De zoekmachine voor universiteitsterminologie gebruiken"
          },
          text : {
            fr : "Cet outil vous permet de chercher un mot ou une expression dans notre base de données. Pour cela, il vous faut choisir la langue dans laquelle vous souhaitez faire une recherche (anglais, néerlandais ou français) pour ensuite entrer votre mot ou expression dans la barre de recherche. Validez avec la touche entrée ou en sélectionnant un élément dans les suggestions automatiques.",
            en : "This tool allows you to search for a word or phrase in our database. To do this, you need to choose the language in which you want to search (English, Dutch or French) and then enter your word or expression in the search bar. Confirm with the enter key or by selecting an item from the automatic suggestions.",
            nl : "Met dit hulpmiddel kunt u een woord of uitdrukking zoeken in onze databank. Om dit te doen, moet u de taal kiezen waarin u wilt zoeken (Engels, Nederlands of Frans) en vervolgens uw woord of uitdrukking in de zoekbalk invoeren. Bevestig met de enter-toets of door een item te selecteren uit de automatische suggesties."
          }
        },
        tip : {
          legend : {
            en : "Tip of the day",
            fr : "Conseil du jour",
            nl : "Tip van de dag"
          },
          description : {
            en : "A quick tip on each visit",
            fr : "Un petit conseil à chaque visite",
            nl : "Een korte tip bij elk bezoek"
          },
          answer : {
            en : "Click here to show the answer",
            fr : "Cliquez ici pour afficher la solution",
            nl : "Klik hier om het antwoord te tone"
          },
        }
      },
      // Selected flag in the langage picker
      selectedFlag : "en",
      // Possible translations for `requestedWords`
      translation : [],
      // Partial matches for `requestedWords`
      partialMatch : [[], []],
      // Suggestions for `requestedWords`
      typingSuggestions : [],
      // Frequent expressions related to `requestWords`
      freqExpr : [],
      // What the user write in the input box
      requestedWords : "",
      // Keep in memory what user wrote in requestedWords,
      // Allows user to write something ine the textbox
      // Without changing page content
      translatedWord : "",
      showAnswer : false,
      errorMessage : "",
      nothingFound : false,
      // Display/Hide help popup
      showHelp : false,
      showTipAnswer : false,
      // Tip of the day
      tip : ""
    }
  },
  props : {
    selectedLang : String
  },
  methods : {
    /**
     * Enable/Disable showing tip's answer
     */
    displayTipAnswer() {
      this.showTipAnswer = !this.showTipAnswer;
    },
    /**
     * Reload current page with different parameters
     */
    redirectToCurrentPage(words){
      this.requestedWords = words;
      this.$router.push({name : '', params : {
          lang : this.selectedFlag,
          word : words
        }});
      this.getTranslation(this.requestedWords);
    },
    /**
     * Retrieve translation, partial matches and frequent expressions related to `item`
     * 
     * @param item : A string containing what user is looking for
     */
    getTranslation (item){
      if (item.length > 0) {
        // Reinitialize suggestion fields
        this.translatedWord = item;
        this.typingSuggestions = [];
        this.requestedWords = item;
        this.showAnswer = true;
        this.partialMatch = [[],[]];
        this.errorMessage = "";
        this.nothingFound = false;
        // Get translation
        getUnivTerminologyTrad(item, this.selectedFlag, (d) => {
          this.translation = d;
          if (d.length == 0) {
            this.nothingFound = true;
          } 
          }, (e) => {
          this.handleError(e);
        });
        //Get partial matches
        getUnivTerminologyPartialMatch(item, this.selectedFlag, (d) => {
          this.partialMatch = d;
        },(e) => {
          this.handleError(e);
        });
        if (this.selectedFlag === 'en') {
          // Get frequent expressions, only available for english
          getUnivTerminologyFreqExpr(item, 
          (d) => {
            this.freqExpr = d
          }, (e) => {
            this.handleError(e);
          });
        } else {
          this.freqExpr = []
        }
      }
    },
    /**
     * Function triggered when a language is picked
     * 
     * @param lang either 'en', 'nl' or 'fr'
     */
    changeLang(lang){
      this.selectedFlag = lang;
      this.typingSuggestions = [];
      this.requestedWords = ""
    },

    /**
     * Refresh suggestions
     */
    onchange(){
      if (this.requestedWords.length > 3){
        getUnivTerminologySuggestions(this.requestedWords, this.selectedFlag, 
        (d) => {
          this.typingSuggestions = d;
        }, (e) => {
           this.handleError(e);
        });
      } else {
        this.typingSuggestions = []
      }
    },
    /**
     * Shows an error message
     * 
     * @param error : The error message
     */
    handleError(error){
      this.showAnswer = false;
      this.errorMessage = error;
    },
    /**
     * Set showHelp to `show`
     * 
     * @param show (boolean) : Value to be set for showHelp
     */
    triggerHelp(show){
      this.showHelp = show;
    },
    hideSuggestion(){
      this.typingSuggestions = []
    }
  },
  // On load function
  activated : function () {
    // load lang from route param if given value is correct
    let langOk = false;
    if (['fr', 'nl', 'en'].includes(this.$route.params.lang)) {
      this.selectedFlag = this.$route.params.lang;
      langOk = true
    }
    // Load word into userword. If not provided, this.$route.params.word
    // simply returns '', which
    if (this.$route.params.word != undefined) {
      this.requestedWords = (this.$route.params.word + this.$route.hash).replaceAll("&#47;", "/");
    }

    if (langOk && this.userWord != "") {
      this.getTranslation(this.requestedWords);
    }
  },
  mounted : function () {
    // Get tip of the day
    getRandomTip((d) => {
        // In case of success, retreive the tip
        this.tip = d
      }, (_) => {
        // In case of failure, do nothing
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* Handle displaying UnivTermino to the right and tip to the left */

#flexContent {
  display : flex;
  justify-content: space-between;
  /* border : 1px solid black; */
  width: 95%;
  margin-left: auto;
  margin-right : auto;
}

#tip {
  width: 25%;
}

#UnivTerminoPart{
  width: 70%;
}

#mainContainer {
  width: 100%;
  height : auto;
}

/* Tip formatting */

#showTextButton{
  width: 100%;
  text-align: center;
  cursor: pointer;
}

#UnivTerminoForm{
  z-index: 99;
  height : 6rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.hidden {
  display: none;
}

h1 {
  text-align: center;
  font-size: 2vw;
}

#destinationLang{
  width: 15%;
  height: 40%;
  margin-right: auto;
  margin-left: auto;
}

#researchInput {
  margin-bottom: 2%;
  margin-top: auto;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  width: 25rem;
  /* height: 50%; */
}

#searchElements {
  width: 100%;
  margin : auto;
  display : flex;
  justify-content: flex-start;
}

#submitButton{
  height: 25%;
}


#suggestions, #inputfield {
  text-align: left;
  width : 84%;
  /* margin: auto; */
}

#suggestions {
  max-height: 300px;
  overflow: auto;
  z-index: 99;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  border : 1px solid #00214e;
}

#suggestions ul {
  list-style-type: none;
  width: 100%;
  padding: 0;
  margin: 0;
}

.suggestionItems {
  color : 00214e;
  width: 99%;
  font-size: 70%;
  padding-top: 2%;
  padding-bottom: 2%;
  background-color: white;
  cursor: pointer;
}

.suggestionItems:hover {
  background-color: #00214e;
  color : rgba(255, 255, 255, 0.8);
}

#errorLabel {
  text-align: center;
}

#responseSection{
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-around;
}

#responseBox, #freqExprBox{
  max-height: 300px;
}

#translationFreqExprBox, #partialMatchBoxContainer{
  width : 40%;
}

#partialMatchCardBody {
  /* border : 1px solid salmon; */
  width: 100%;
  height: 100%;
}

#partialMatchList {
  width: 100%;
  max-height: 500px;
  overflow: auto;
}

#partialMatchBoxContainer{
  height: 100%;
}

#partialMatchBoxContainer .card-body {
  width: 100%;
  height: 100%;
}

.partialMatch {
  cursor: pointer;
}

/* #responseBox div{
  width: 100%;
} */

#responseBox{
  overflow: auto;
}

.translationItem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 1%;
  overflow: auto;
}

.flagContainer {
  width: 10%;
}

#searchWordDetails {
  display : flex;
  justify-content: space-evenly;
}

.translationItemsContainer {
  width: 80%;
}

.translationLangBullet {
  font-size: 100%;
  margin-right: 3%;
  overflow: hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;
}

#freqExprBox {
  width: 100%;
  height: 30vh;
}

#freqExprList{
  width: 100%;
  height: 18vh;
  overflow: auto;
}

/* Small screen display */
@media screen and (max-width: 850px) {
  /* Adjust flex for tip of the day */
  #flexContent {
    flex-direction: column;
    width: 100%;
  }

  #tip {
    width: 100%;
  }

  #UnivTerminoPart{
    width: 100%;
  }

  #mainContainer{
    display: flex;
    flex-direction: column;
    height: auto;
  }

  #UnivTerminoForm {
    height: 8rem;
  }

  #titleContainer, #UnivTerminoForm, #responseSection{
    margin-top: 0%;
  }

  h1 {
    font-size: 8vw;
  }

  #destinationLang{
    width: 30%;
  }

  #responseSection {
    width: 95%;
    /* height: 100vh; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  #translationFreqExprBox, #partialMatchBoxContainer{
    width : 90%!important;
    margin-left: auto;
    margin-right: auto;
  }

  .flagContainer{
    width : 15vw!important;
  }

  #suggestions, #inputfield {
    width : 90%;
  }

  #partialMatchBoxContainer{
    margin-top: 10%;
  }
}

@media screen and (max-width: 850px) and (orientation : landscape){
  h1 {
    font-size: 5vw;
  }

  #titleContainer, #UnivTerminoForm, #responseSection{
    margin-top: 5%;
  }

  #mainContainer {
    height: auto;
  }

  .flagContainer{
    width : 10vw!important;
  }

  #translationFreqExprBox {
    display : flex;
  }
  
  #freqExprBox {
   height: 60vh;
  }

  #freqExprBox, #responseBox {
    width: 100%;
  }

  #freqExprList{
    width: 100%;
    height: 90%;
    overflow: auto;
  }

  #freqExprCardBody {
    height: 100%;
  }

  #responseSection {
    margin-left: auto;
    margin-right : auto;
  }
}

</style>
